export default __webpack_public_path__ + "static/media/question.ea488dff.svg";